import type { AppEnvironment } from './app-environment.model';

export const environment: AppEnvironment = {
  production: false,
  oneSignal: {
    /**
     * `false` en local: no llama al CDN (evita ERR_BLOCKED_BY_CLIENT en Brave Shields / adblock).
     * Pon `true` solo si vas a probar push y permites cdn.onesignal.com en el navegador.
     */
    enabled: false,
    appId: 'cb715276-c521-4af4-94f5-429420b1b7ca',
    allowLocalhostAsSecureOrigin: true,
  },
  /** Maquetación del módulo Ingest sin depender del API; false = API Vault desplegado. */
  ingestUiMock: false,
  API_BASE_URL: 'https://api-dev.centricasoluciones.com',
  /**
   * En local (`nx serve`), cadena vacía + `proxy.conf.json` evita CORS: el navegador llama a
   * `http://localhost:4300/api/...` y el dev server reenvía al API Vault DEV (`10.120.0.2:8547`).
   */
  API_VAULT: '',
  /** POST/GET/PUT `/api/admin/user-tenants` montado en DEV Vault. */
  vaultAdminUserTenantsApiEnabled: true,
  SECRET:
    'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE3Mjg3NjY1OTksImV4cCI6MTc2MDMwMjU5OSwiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoianJvY2tldEBleGFtcGxlLmNvbSIsIkdpdmVuTmFtZSI6IkpvaG5ueSIsIlN1cm5hbWUiOiJSb2NrZXQiLCJFbWFpbCI6Impyb2NrZXRAZXhhbXBsZS5jb20iLCJSb2xlIjpbIk1hbmFnZXIiLCJQcm9qZWN0IEFkbWluaXN0cmF0b3IiXX0.Bn9SWBpj_5emT0T5QQYidL4Mtp-qnjztx40qgJ49Jy6Q6EtdoAi5vLseAkpTaFDKR8aCN5_6StK0lra1ppm-BA',
};
